export const convertStringToObject = (data) => JSON.parse(data);
export const convertObjectToString = (data) => JSON.stringify(data);
